import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from "@angular/core";
import {map, share, startWith, tap} from "rxjs/operators";
import {ILookupTable, LookupResponse, LookupsService} from "../../../lookups";
import {BehaviorSubject, combineLatest, Observable, Subject} from "rxjs";
import {ComboBoxComponent} from "@progress/kendo-angular-dropdowns";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

// TODO: think about moving this component to somewhere more shareable...
@UntilDestroy()
@Component({
	selector: 'cp-icon-selection-component',
	templateUrl: './icon.selection.template.html',
	styleUrls: ['./icon.selection.style.scss']
})
export class IconSelectionComponent implements OnInit, OnChanges, OnDestroy{
	@ViewChild('list',{static:true}) list:ComboBoxComponent;

	icons$:Observable<any>;
	selectedObj;

	@Input() selectedIconClassOrKey:string|number;
	@Input() selectionProperty:"icon"|"iconKey"="icon";
	@Input() readOnly :boolean=false;
	@Input() showRequiredIndication :boolean=false;

	@Output() selected:EventEmitter<string|number> = new EventEmitter();

	private selectedIconClassOrKeySubject:BehaviorSubject<string|number>;

	constructor(private lookupsService:LookupsService){

	}

	public openComboBox(event,comboBoxComponent){ // TODO - consder moving to a helper service
		if (!comboBoxComponent.isOpen && event && event.srcElement && event.srcElement.nodeName === 'INPUT') {
			comboBoxComponent.toggle(true);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['selectedIconClassOrKey']) {
			if (!this.selectedIconClassOrKeySubject) {
				this.selectedIconClassOrKeySubject = new BehaviorSubject<string | number>(this.selectedIconClassOrKey);
			} else {
				this.selectedIconClassOrKeySubject.next(this.selectedIconClassOrKey);
			}
		}
	}

	ngOnInit(): void {
		let request = this.lookupsService.createRequestGetAllRecords("ICON");

		let iconsObserv=this.lookupsService.getLookup(request)
			.pipe(map((res: LookupResponse<any>) => {
				let myData =[...res.lookupTable.data];
				myData.sort((a,b)=>a["name"].localeCompare(b["name"]));
				return myData;
			})).pipe(share());

		combineLatest(
			iconsObserv,
			this.selectedIconClassOrKeySubject.asObservable(),
			(data: any[], currSelected) => data.find(curr => curr[this.selectionProperty] === currSelected)
		).pipe(untilDestroyed(this)).subscribe(curr => {
			//console.log(curr);
			this.selectedObj = curr;
		});

		this.icons$ = combineLatest(
			this.list.filterChange.asObservable().pipe(startWith('')),
			iconsObserv,
			(f:string,values)=>values.filter(c=>c.name.toLowerCase().indexOf(f.toLowerCase())>-1));

	}

	selectIcon($event){
		let val=$event?$event[this.selectionProperty]:undefined;
		this.selectedIconClassOrKeySubject.next(val);
		this.selected.emit(val);
	}

	ngOnDestroy(): void {
	}
}
